import api_user from "../../api/api_user.js"
import router from "../../router.js"

const state = {
  token: window.localStorage.getItem('token'),
  username: window.localStorage.getItem('username'),
  admin: window.localStorage.getItem('admin'),
  staff: window.localStorage.getItem('staff'),
  profile: null,
  position: null,
  error: null,
  userSites: null,
  userServiceSites: null,
  userSitesArray: null,
  userServiceSitesArray: null,
  userPermissionsArray: null,
  userSiteServicesArray: null,
  userPermissionsUsername: null,
  userList: null,
  siteAdmin: null,
  noProfile: "",
};


const getters = {
// Check if token exists or not
  isLoggedIn: state => !!state.token || !!state.username,
  getUsername: state => state.username,
  getProfile: state => state.profile,
  getPosition: state => state.position,
  getToken: state => state.token,
  getAdmin: state => state.admin,
  getStaff: state => state.staff,
  getSiteAdmin: state => state.siteAdmin,
  getError: state => state.error,
  getUserSites: state => state.userSites,
  getUserServiceSites: state => state.userServiceSites,
  getUserSitesArray: state => state.userSitesArray,
  getUserServiceSitesArray: state => state.userServiceSitesArray,
  getNoProfile: state => state.noProfile,

  getUserPermissionsArray: state => state.userPermissionsArray,
  getUserPermissionsUsername: state => state.userPermissionsUsername,
  getUserList: state => state.userList,
  getUserSiteServices: state => state.userSiteServicesArray,
};


const actions = {
  async fetchUserList({ commit }) {
    const response = await api_user.userList();
    if (!response) {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    }
    else {
      commit('setUserList', response.queryset);

    }
  },
  async getUserInfo({ commit }) {
    const response = await api_user.userInfo();
    if (response["email"] || response["username"]) {
      const username = response["email"] || response["username"];
      window.localStorage.setItem('username', username);
      const admin = response["admin"];
      window.localStorage.setItem('admin', admin);
      const staff = response["staff"];
      window.localStorage.setItem('staff', staff);
      const site_permissions = response["site_permissions"];
      window.localStorage.setItem('site_permissions', site_permissions);
    }
    else {
      commit('setUsername', null);
      commit('setAdmin', null);
      commit('setStaff', null);
      window.localStorage.setItem('admin', null);
      window.localStorage.setItem('username', null);
      window.localStorage.setItem('staff', null);
    }
  },
  async fetchUserProfile({ commit }) {
    const response = await api_user.userProfile();
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    }
    else {
      if ( response.user_profile ) {
        commit('setProfile', response.user_profile);
        commit('setNoProfile', "");
      } else {
        console.log(response);
        commit('setNoProfile', "None");
      }
    }
  },
  async performUpdateUserProfile({commit}, payload) {
    const response = await api_user.updateUserProfile(payload)
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    } else {
      commit('setProfile', null);
      router.push(`/profile-success`);
    }
  },
  async performCreateProfile({commit}) {
    const response = await api_user.createUserProfile()
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    } else {
      commit('setProfile', null);
      router.push(`/profile-success`);
    }
  },
  async fetchUserSites({ commit }) {
    commit("setLoader", true);
    const response = await api_user.userSites();

    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
      commit("setLoader", false);
    }
    else {
      commit('setUserSites', response.user_sites);
      commit('setUserSitesArray', response.user_sites_list);
      commit('setSiteAdmin', response.site_admin);
      commit("setLoader", false);
    }
  },
  async fetchUserServiceSites({ commit }) {
    commit("setLoader", true);
    const response = await api_user.userServiceSites();

    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
      commit("setLoader", false);
    }
    else {
      commit('setUserServiceSites', response.user_service_sites);
      commit('setUserServiceSitesArray', response.user_service_sites_list);
      commit('setSiteAdmin', response.site_admin);
      commit("setLoader", false);
    }
  },
  async fetchUserSiteServices({ commit }) {
    commit("setLoader", true);
    const response = await api_user.userSiteServices();
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
      commit("setLoader", false);
    }
    else {
      commit('setUserSiteServices', response.available_services);
      commit("setLoader", false);
    }
  },
  async fetchUserPermissions({commit}, payload) {
    const response = await api_user.userPermissions(payload.id);
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    } else {
      commit("setUserPermissionsArray", response.queryset);
      commit("setUserPermissionsUsername", response.username);
    }
  },
  async performUpdateSitePermissions({commit}, payload) {
    const response = await api_user.updateSitePermissions(payload)
    if (!response)  {
      commit("setFormError", "Something went wrong. Try again later");
      setTimeout(() => document.getElementById("formError").style.display = "none", 5000);
    } else {
      router.push(`/user-permissions`);
    }
  },
};


const mutations = {
// Update user
  setUserList: (state, userList) => {
    state.userList = userList
  },
  setUsername: (state, username) => {
    state.username = username
  },
  setAdmin: (state, admin) => {
    state.admin = admin
  },
  setStaff: (state, staff) => {
    state.staff = staff
  },
  setSiteAdmin: (state, siteAdmin) => {
    state.siteAdmin = siteAdmin
  },
  setProfile: (state, profile) => {
    state.profile = profile
  },
  setNoProfile: (state, noProfile) => {
    state.noProfile = noProfile
  },
  setPosition: (state, position) => {
    state.position = position
  },
  setUserSites: (state, userSites) => {
    state.userSites = userSites
  },
  setUserServiceSites: (state, userServiceSites) => {
    state.userServiceSites = userServiceSites
  },
  setUserSitesArray: (state, userSitesArray) => {
    state.userSitesArray = userSitesArray
  },
  setUserServiceSitesArray: (state, userServiceSitesArray) => {
    state.userServiceSitesArray = userServiceSitesArray
  },
  setUserPermissionsArray: (state, userPermissionsArray) => {
    state.userPermissionsArray = userPermissionsArray
  },
  setUserPermissionsUsername: (state, userPermissionsUsername) => {
    state.userPermissionsUsername = userPermissionsUsername
  },
  setUserSiteServices: (state, userSiteServicesArray) => {
    state.userSiteServicesArray = userSiteServicesArray
  },
};


export default {
  state,
  getters,
  actions,
  mutations
}